
import Vue from "vue"
import Component from "vue-class-component"
import Error from "@/components/Error.vue"

@Component({
  components: {
    Error
  }
})
export default class Login extends Vue {
  private loading = false
  private successMessageKey: string | null = null
  public passwordShow = false
  public valid = false
  public email = ""
  public emailRules = [
    (v: any) => !!v || this.$t('global.required'),
    (v: any) => /.+@.+\..+/.test(v) || this.$t('account.mailNotValid')
  ]

  public password = ""
  public passwordRules = [(v: any) => !!v || this.$t('global.required')]

  created () {
    if (this.$route.params) {
      if (this.$route.params.email) {
        this.email = this.$route.params.email
      }
      if (this.$route.params.password) {
        this.password = this.$route.params.password
      }
      if (this.$route.params.successMessageKey) {
        this.successMessageKey = this.$route.params.successMessageKey
        setTimeout(() => {
          this.successMessageKey = null
        }, 5000)
      }
    }
  }

  private get isValidEMail () {
    return /.+@.+\..+/.test(this.email)
  }

  public goToRegister () {
    this.$store.commit('account/setAuthenticationError', null)
    this.$router.push({ name: 'register', params: { email: this.email, password: this.password } })
  }

  public forgotPassword () {
    this.$store.dispatch("account/sendPasswordResetMail", this.email)
    this.$store.commit('account/setAuthenticationError', null)
  }

  public resendAccountVerificationMail () {
    this.loading = true
    this.$store.dispatch("account/resendMail", this.email)
      .then(() => {
        this.loading = false
        this.successMessageKey = 'account.successMessagePasswordReset'
        setTimeout(() => {
          this.successMessageKey = null
        }, 5000)
      })
  }

  public login () {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.loginUser()
    }
  }

  get error () {
    const authenticationError = this.$store.getters["account/authenticationError"]
    const globalError = this.$store.getters["error/error"]
    if (authenticationError || globalError) {
      this.loading = false
    }
    return authenticationError
  }

  loginUser () {
    this.loading = true
    const user = {
      email: this.email,
      password: this.password
    }
    this.$store.dispatch("account/login", user)
  }
}
